export const RotasNaoProtegidas = [
  '/visita-formulario-leads',
  '/ibge/lista-estados',
  '/ibge/lista-cidades',
  '/formulario-leads',
  '/escopo-ambiente',
  '/authentication',
  '/login'
];
